import React from 'react'
import Download from './download'
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })

//配置项
let componentName = 'preAudit'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '品牌',
    name: 'orgName',
    dataIndex: 'orgName',
    tableItem: {}
  },
  {
    title: '品牌',
    name: 'orgId',
    dataIndex: 'orgId',
    searchItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio'
    },
    formItem: {
      ...organizationConfig,
      diy: WizTableForm,
      selectType: 'radio',
      rules: [{ required: true, message: '请选择品牌' }]
    }
  },
  {
    title: '辅导模块',
    name: 'moduleType',
    dataIndex: 'moduleType',
    dict: [
      { code: 0, codeName: '销售' },
      { code: 1, codeName: '售后' }
    ],
    searchItem: {
      type: 'select'
    },
    formItem: {
      type: 'select',
      rules: [{ required: true, message: '请选择辅导模块' }]
    },
    tableItem: {
      type: 'select'
    }
  },
  {
    title: '上传时间',
    name: 'uploadTime',
    dataIndex: 'uploadTime',
    tableItem: {}
  },
  {
    title: '上传人',
    name: 'uploadFullName',
    dataIndex: 'uploadFullName',
    tableItem: {}
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ],
        collapse: false,
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['upload', 'download'],
      rowOperateView: [
        {
          key: 'upload',
          custom: true,
          params: { children: '上传' },
          customOnClick: {
            key: 'jumpPage',
            params: {
              key: 'push',
              pathname: '/integrationCounseling/config/preAudit/import'
            }
          }
        },
        {
          key: 'download',
          custom: true,
          params: { children: '下载' },
          customOnClick: {
            key: 'modal',
            params: {
              modalKey: 'preAuditDownload',
              modalParams: {
                title: '下载预审核标准',
                style: { minWidth: 700 },
                diy: (e) => {
                  return <Download key={'preAuditDownload_' + e.record.id} ref={r => ref = r && r.getWrappedInstance()} {...e} />
                },
                onOk: () => {
                  ref._ok()
                },
                width: 600
              },
            }
          },
          recordChangeParams: ({ record, rows }) => {
            let disabled = !record.uploadTime 
            return { disabled }
          }
        }
      ]
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
